module.exports = __webpack_public_path__ + "img/offering.f2a13c56.jpg";